var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpressShopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28988 3.75886C4.42317 3.36668 4.84915 3.15681 5.24133 3.2901L6.95513 3.87256C7.72667 4.13478 8.29911 4.78953 8.45597 5.58917L8.50717 5.8502H20.7252C21.8604 5.8502 22.6952 6.91438 22.4248 8.01695L21.402 12.1884C21.1004 13.4185 19.9977 14.2835 18.7311 14.2835H10.1614L10.3492 15.2408C10.4642 15.8272 10.9782 16.2502 11.5758 16.2502H18.6C19.0142 16.2502 19.35 16.586 19.35 17.0002C19.35 17.4144 19.0142 17.7502 18.6 17.7502H11.5758C10.2611 17.7502 9.13028 16.8197 8.87722 15.5295L6.98408 5.87823C6.93061 5.60566 6.73543 5.38216 6.47244 5.29278L4.75865 4.71031C4.36646 4.57702 4.15659 4.15104 4.28988 3.75886Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22C12.3284 22 13 21.3284 13 20.5C13 19.6716 12.3284 19 11.5 19C10.6716 19 10 19.6716 10 20.5C10 21.3284 10.6716 22 11.5 22Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20.5C19 21.3284 18.3284 22 17.5 22C16.6716 22 16 21.3284 16 20.5C16 19.6716 16.6716 19 17.5 19C18.3284 19 19 19.6716 19 20.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18.25C2.58579 18.25 2.25 18.5858 2.25 19C2.25 19.4142 2.58579 19.75 3 19.75H8C8.41421 19.75 8.75 19.4142 8.75 19C8.75 18.5858 8.41421 18.25 8 18.25H3Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 16C1.25 15.5858 1.58579 15.25 2 15.25H6C6.41421 15.25 6.75 15.5858 6.75 16C6.75 16.4142 6.41421 16.75 6 16.75H2C1.58579 16.75 1.25 16.4142 1.25 16Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.25C1.58579 12.25 1.25 12.5858 1.25 13C1.25 13.4142 1.58579 13.75 2 13.75H5C5.41421 13.75 5.75 13.4142 5.75 13C5.75 12.5858 5.41421 12.25 5 12.25H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressShopping);
export default __webpack_public_path__ + "static/media/express-shopping.7473aeb099b01875ee8e61e6ed727634.svg";
export { ForwardRef as ReactComponent };